import { render } from "./chinaIndex.vue?vue&type=template&id=13dc6638&scoped=true"
import script from "./chinaIndex.vue?vue&type=script&lang=js"
export * from "./chinaIndex.vue?vue&type=script&lang=js"

import "./chinaIndex.vue?vue&type=style&index=0&id=13dc6638&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dc6638"]])

export default __exports__